export default {"src":"https://fishbrain.com/_next/static/media/kansas.c33a1cda.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};